"use client";

import * as React from "react"

import { cn } from "@/utils/tailwind"

// Hook to check archival mode (lazy import to avoid circular deps)
let useArchivalModeHook: (() => { isArchivalMode: boolean }) | null = null;
try {
  const archivalContext = require("@/contexts/ArchivalModeContext");
  useArchivalModeHook = archivalContext.useArchivalMode;
} catch {
  // Context not available
}

function Input({ className, type, disabled, ...props }: React.ComponentProps<"input">) {
  // Check archival mode
  let isArchivalMode = false;
  try {
    if (useArchivalModeHook) {
      const archival = useArchivalModeHook();
      isArchivalMode = archival.isArchivalMode;
    }
  } catch {
    // Context not available
  }

  // Disable input in archival mode unless explicitly allowed via data-allow-archival-edit
  const effectiveDisabled = disabled || (isArchivalMode && !(props as any)["data-allow-archival-edit"]);

  // Remove our custom data attribute before passing to native input
  const { "data-allow-archival-edit": _, ...restProps } = props as any;

  return (
    <input
      type={type}
      data-slot="input"
      disabled={effectiveDisabled}
      className={cn(
        "file:text-foreground placeholder:text-muted-foreground/60 selection:bg-primary selection:text-primary-foreground dark:bg-white/5 border-white/10 flex h-9 w-full min-w-0 rounded-md border bg-white/5 px-3 py-1 text-base shadow-sm transition-all outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm backdrop-blur-sm",
        "focus-visible:border-primary/50 focus-visible:ring-2 focus-visible:ring-primary/20",
        "hover:border-white/20 hover:bg-white/10",
        "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
        className
      )}
      {...restProps}
    />
  )
}

export { Input }
